import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const TXN_TYPES = [
  { value: '', label: 'All Types' },
  { value: 'recharge', label: 'Recharge' },
  { value: 'consultation_debit', label: 'Consultation Debit' },
  { value: 'consultation_credit', label: 'Earnings Credit' },
  { value: 'withdrawal', label: 'Withdrawal' },
  { value: 'refund', label: 'Refund' },
  { value: 'promo_credit', label: 'Promo' },
];

const TransactionFilters = ({ filters, onChange }) => {
  const handle = (field) => (e) => onChange({ ...filters, [field]: e.target.value });

  return (
    <Row className="mb-3 g-2">
      <Col xs={12} sm={4}>
        <Form.Select size="sm" value={filters.type || ''} onChange={handle('type')}>
          {TXN_TYPES.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </Form.Select>
      </Col>
      <Col xs={6} sm={4}>
        <Form.Control
          size="sm"
          type="date"
          value={filters.from || ''}
          onChange={handle('from')}
          placeholder="From"
        />
      </Col>
      <Col xs={6} sm={4}>
        <Form.Control
          size="sm"
          type="date"
          value={filters.to || ''}
          onChange={handle('to')}
          placeholder="To"
        />
      </Col>
    </Row>
  );
};

export default TransactionFilters;
